<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Push Through Bar Spring</h2>
        <h3></h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="contrology-Walltower-accessory-extraspring-1@1x.jpg"
              src2="contrology-Walltower-accessory-extraspring-1@2x.jpg"
              alt="Push Through Bar Spring angle 1"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-Walltower-accessory-extraspring-2@1x.jpg"
              src2="contrology-Walltower-accessory-extraspring-2@2x.jpg"
              alt="Push Through Bar Spring angle 2"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-Walltower-accessory-extraspring-3@1x.jpg"
              src2="contrology-Walltower-accessory-extraspring-3@2x.jpg"
              alt="Push Through Bar Spring usage"
            />
          </photo-grid>

          <cta-prod-button
            class="cta-button wide"
            link="wall-tower"
            src="contrology-walltower-highmat-5_1x.jpg"
            src2="contrology-walltower-highmat-5_2x.jpg"
            alt="Close-up photo of Contrology Wall Tower thumbnail"
            productName="Wall Tower"
            productSub=''
          />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Push Through Bar Spring</h2>
              <h3></h3>
              <p>
                Our new Contrology Wall Tower includes 2 Push Through Bar Springs. By adding a third and fourth spring you can increase the resistance, making exercises progressively more challenging. We sell the individual Contrology Wall Tower Push Through Bar Spring to empower you to progress in your practice when you are ready! 
              </p>
              <p>
                Contrology® Springs are the most authentic version available of the original Pilates springs. Fully-tested and guaranteed to provide the unique classical feel you expect.
              </p>
              <p>
                Dimensions:<br/>
                Width: 8” (20.32cm)<br/>
                Diameter: 1.25” (3.175cm)
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >1 Year Warranty</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <cta-prod-button
              class="cta-button"
              link="wall-tower"
              src="contrology-walltower-highmat-5_1x.jpg"
              src2="contrology-walltower-highmat-5_2x.jpg"
              alt="Close-up photo of Contrology Wall Tower thumbnail"
              productName="Wall Tower"
              productSub=''
            />

            <section class="more">
              <tertiary-button text="More Springs" url="/accessories/Springs" />
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaProdButton from "@/components/CtaProdButton.vue";
import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "springsleeves",

  metaInfo: {
    title: "Contrology Push Through Bar Spring - Balanced Body",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: ""
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaProdButton,
    TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      product: {
        label: "Select",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 48868191928513,
          partnumber: 16912,
          price: 70,
          name: "Push Through Bar Spring",
          available: true
        }
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.krn-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
  margin-top: 3rem;
}

.krn-image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding-right: 0;
}

.krn-image-container img {
  width: 180px;
  height: 180px;
}

.krn-image-container p {
  font-size: 10px;
  margin: 1rem 0 0 0;
}

.krn-quote-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem 0;
}

.krn-quote {
  margin-bottom: 24px;
  margin-top: 0;
  font-size: 18px;
  font-family: var(--noto);
  font-style: italic;
}

.krn-name {
  font-weight: 500;
  font-size: 15px;
  margin: 0;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 100%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 60%;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }

  .krn-container {
    max-width: 775px;
  }

  .krn-container {
    flex-direction: row;
  }

  .krn-image-container {
    margin: 0;
    padding-right: 2rem;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 20px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
